module.exports = __webpack_public_path__ + "static/media/xilnex_official_logo_grey.7ba8e783.svg";